import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
`;

const ContentWrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Breadcrumbs = styled.nav`
  margin-bottom: 30px;
  font-size: 14px;
  color: #666;

  a {
    color: #4f46e5;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  span {
    margin: 0 8px;
    color: #999;
  }
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
`;

const AppBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #4f46e5;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 2.2rem;
  color: #1a1a1a;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const Subtitle = styled.p`
  color: #666;
  font-size: 15px;
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.6;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    padding: 25px;
  }
`;

const Section = styled.section`
  margin-bottom: 30px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  color: #1a1a1a;
  font-size: 1.2rem;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Paragraph = styled.p`
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
  font-size: 15px;
`;

const List = styled.ul`
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 25px;

  li {
    margin-bottom: 8px;
    font-size: 15px;
  }
`;

const WarningBox = styled.div`
  background: #fef2f2;
  border-left: 4px solid #ef4444;
  padding: 15px 20px;
  border-radius: 0 8px 8px 0;
  margin: 20px 0;

  p {
    margin: 0;
    color: #991b1b;
    font-size: 14px;
    line-height: 1.6;
  }

  strong {
    color: #7f1d1d;
  }
`;

const InfoBox = styled.div`
  background: #f0f4ff;
  border-left: 4px solid #4f46e5;
  padding: 15px 20px;
  border-radius: 0 8px 8px 0;
  margin: 20px 0;

  p {
    margin: 0;
    color: #444;
    font-size: 14px;
    line-height: 1.6;
  }

  strong {
    color: #1a1a1a;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e8eeff;
  margin: 30px 0;
`;

const Form = styled.form`
  margin-top: 20px;
`;

const FormGroup = styled.div`
  margin-bottom: 18px;
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 6px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #4f46e5;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  min-height: 80px;
  resize: vertical;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #4f46e5;
  }
`;

const SubmitButton = styled.button`
  background: #ef4444;
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s;

  &:hover {
    background: #dc2626;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const SuccessMessage = styled.div`
  background: #f0fdf4;
  border: 2px solid #22c55e;
  border-radius: 12px;
  padding: 25px;
  text-align: center;

  h3 {
    color: #166534;
    margin-bottom: 10px;
  }

  p {
    color: #444;
    font-size: 14px;
    line-height: 1.6;
  }
`;

const RelatedLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;

  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #eef2ff;
    color: #4f46e5;
    padding: 12px 20px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
      background: #4f46e5;
      color: white;
    }
  }
`;

export const ConectaEliminarCuentaPage = () => {
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const mailtoLink = `mailto:soporte@monaco-it-services.cl?subject=${encodeURIComponent(
        "Solicitud de eliminacion de cuenta - Conecta"
      )}&body=${encodeURIComponent(
        `Solicito la eliminacion de mi cuenta de Conecta.\n\nEmail de la cuenta: ${email}\nMotivo: ${reason || "No especificado"}\n\nEntiendo que esta accion es permanente y que todos mis datos seran eliminados.`
      )}`;
      window.location.href = mailtoLink;
      setSubmitted(true);
    } catch (err) {
      setSubmitted(true);
    }

    setLoading(false);
  };

  return (
    <>
      <Navbar />
      <PageContainer>
        <ContentWrapper>
          <Breadcrumbs>
            <Link to="/">Inicio</Link>
            <span>&rsaquo;</span>
            <Link to="/conecta/soporte">Soporte Conecta</Link>
            <span>&rsaquo;</span>
            <span>Eliminar Cuenta</span>
          </Breadcrumbs>

          <Header>
            <AppBadge>Conecta</AppBadge>
            <Title>Eliminar mi Cuenta</Title>
            <Subtitle>
              Puedes solicitar la eliminacion permanente de tu cuenta y todos los
              datos asociados.
            </Subtitle>
          </Header>

          <Card>
            <Section>
              <SectionTitle>Que datos se eliminan?</SectionTitle>
              <Paragraph>
                Al eliminar tu cuenta, se borran permanentemente todos tus datos,
                incluyendo:
              </Paragraph>
              <List>
                <li>Tu perfil y datos de registro (nombre, email)</li>
                <li>Todos los check-ins y reflexiones diarias</li>
                <li>Grabaciones de voz y transcripciones</li>
                <li>Conversaciones con el coach de IA</li>
                <li>Progreso del programa, puntos y estadisticas</li>
                <li>Resumenes semanales y cuestionarios</li>
                <li>Preferencias y configuracion de notificaciones</li>
              </List>
              <WarningBox>
                <p>
                  <strong>Esta accion es irreversible.</strong> Una vez eliminada
                  tu cuenta, no podemos recuperar ningun dato. Asegurate de
                  descargar cualquier informacion que desees conservar antes de
                  proceder.
                </p>
              </WarningBox>
            </Section>

            <Divider />

            <Section>
              <SectionTitle>Como eliminar tu cuenta</SectionTitle>

              <InfoBox>
                <p>
                  <strong>Opcion 1 — Desde la app:</strong> Abre Conecta, ve a
                  tu Perfil y selecciona "Eliminar cuenta" al final de la
                  pagina. Se te pedira confirmacion antes de proceder.
                </p>
              </InfoBox>

              <Paragraph>
                <strong>Opcion 2 — Desde este formulario:</strong> Si no puedes
                acceder a la app, completa el formulario a continuacion y
                procesaremos tu solicitud en un plazo maximo de 48 horas.
              </Paragraph>
            </Section>

            <Divider />

            <Section>
              <SectionTitle>Solicitar eliminacion por email</SectionTitle>

              {submitted ? (
                <SuccessMessage>
                  <h3>Solicitud enviada</h3>
                  <p>
                    Se ha abierto tu cliente de correo con la solicitud
                    pre-completada. Envia el email a{" "}
                    <strong>soporte@monaco-it-services.cl</strong> y
                    procesaremos tu solicitud en un plazo maximo de 48 horas.
                  </p>
                  <p>
                    Si tu cliente de correo no se abrio, envia un email
                    manualmente a{" "}
                    <a href="mailto:soporte@monaco-it-services.cl">
                      soporte@monaco-it-services.cl
                    </a>{" "}
                    indicando el email de tu cuenta de Conecta.
                  </p>
                </SuccessMessage>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <FormGroup>
                    <Label>Email de tu cuenta de Conecta *</Label>
                    <Input
                      type="email"
                      placeholder="tu@email.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Motivo (opcional)</Label>
                    <TextArea
                      placeholder="Cuentanos por que deseas eliminar tu cuenta..."
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </FormGroup>
                  <SubmitButton type="submit" disabled={loading || !email}>
                    {loading ? "Procesando..." : "Solicitar eliminacion de cuenta"}
                  </SubmitButton>
                </Form>
              )}
            </Section>

            <RelatedLinks>
              <Link to="/conecta/privacidad">Politica de Privacidad</Link>
              <Link to="/conecta/soporte">Centro de Soporte</Link>
            </RelatedLinks>
          </Card>
        </ContentWrapper>
      </PageContainer>
      <Footer />
    </>
  );
};
